import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfigurationForm = ({
  formData,
  errors,
  onChange,
  onSave,
  isSaving,
}) => {
  const { t } = useTranslation();

  const handleChange = (field) => (e) => {
    onChange(field, e?.target?.value);
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Settings" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground">{t('ai.config.title')}</h2>
          <p className="text-sm text-muted-foreground">{t('ai.config.subtitle')}</p>
        </div>
      </div>

      <div className="space-y-4 md:space-y-5">
        <Input
          label={t('ai.config.agentName')}
          type="text"
          placeholder={t('ai.config.agentNamePlaceholder')}
          description={t('ai.config.agentNameHint')}
          value={formData?.agentName}
          onChange={handleChange('agentName')}
          error={errors?.agentName}
          required
        />

        <Input
          label={t('ai.config.companyName')}
          type="text"
          placeholder={t('ai.config.companyNamePlaceholder')}
          description={t('ai.config.companyNameHint')}
          value={formData?.companyName}
          onChange={handleChange('companyName')}
          error={errors?.companyName}
          required
        />

        <Input
          label={t('ai.config.linkedinLink')}
          type="url"
          placeholder={t('ai.config.linkedinPlaceholder')}
          description={t('ai.config.linkedinHint')}
          value={formData?.linkedinUrl}
          onChange={handleChange('linkedinUrl')}
          error={errors?.linkedinUrl}
          required
        />

        <div className="pt-2">
          <Button
            type="button"
            variant="default"
            iconName="Save"
            iconPosition="left"
            loading={isSaving}
            onClick={onSave}
          >
            {isSaving ? t('ai.config.saving') : t('common.save')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfigurationForm;
